import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eec2252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news__container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "news_item__image_container" }
const _hoisted_4 = { class: "news_item__content" }
const _hoisted_5 = { class: "news_item__date" }
const _hoisted_6 = { class: "news_item__title" }
const _hoisted_7 = {
  key: 0,
  class: "news_item__tags"
}
const _hoisted_8 = { class: "news_item__text" }
const _hoisted_9 = { class: "news_item__readmore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _component_page_section = _resolveComponent("page-section")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_page_section, { class: "news" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            href: item.href,
            class: "news_item",
            key: `newsitem-${item.href}`,
            "data-reveal-on-scroll": "true"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "news_item__image",
                style: _normalizeStyle(`background-image:url('${item.image}')`)
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.date), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
              (item.tags)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "news_item__tag",
                        key: `newsitem-tag-${tag}`
                      }, _toDisplayString(tag), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                [_directive_sanitize, _ctx.summarizeText(item.text)]
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ButtonLink, {
                  label: "lees meer",
                  link: item.href
                }, null, 8, ["link"])
              ])
            ])
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}